/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginRouteImport } from './routes/login'
import { Route as Sign_upRouteImport } from './routes/sign_up'
import { Route as WSlugRouteRouteImport } from './routes/w/$slug/route'
import { Route as WSlugIndexRouteImport } from './routes/w/$slug/index'
import { Route as WSlugAccountRouteImport } from './routes/w/$slug/account'
import { Route as WSlugWelcomeRouteImport } from './routes/w/$slug/welcome'
import { Route as WSlugAdjustmentsIndexRouteImport } from './routes/w/$slug/adjustments/index'
import { Route as WSlugAdjustmentsNewRouteImport } from './routes/w/$slug/adjustments/new'
import { Route as WSlugAssembliesIndexRouteImport } from './routes/w/$slug/assemblies/index'
import { Route as WSlugAssembliesNewRouteImport } from './routes/w/$slug/assemblies/new'
import { Route as WSlugBatchesIndexRouteImport } from './routes/w/$slug/batches/index'
import { Route as WSlugBatchesNewRouteImport } from './routes/w/$slug/batches/new'
import { Route as WSlugChannelsIndexRouteImport } from './routes/w/$slug/channels/index'
import { Route as WSlugChannelsNewRouteImport } from './routes/w/$slug/channels/new'
import { Route as WSlugCogsIndexRouteImport } from './routes/w/$slug/cogs/index'
import { Route as WSlugCogsVariantIdRouteImport } from './routes/w/$slug/cogs/$variantId'
import { Route as WSlugDispatchesIndexRouteImport } from './routes/w/$slug/dispatches/index'
import { Route as WSlugDispatchesNewRouteImport } from './routes/w/$slug/dispatches/new'
import { Route as WSlugExpensesIndexRouteImport } from './routes/w/$slug/expenses/index'
import { Route as WSlugExpensesNewRouteImport } from './routes/w/$slug/expenses/new'
import { Route as WSlugGuideIndexRouteImport } from './routes/w/$slug/guide/index'
import { Route as WSlugGuideMcpRouteImport } from './routes/w/$slug/guide/mcp'
import { Route as WSlugMachinesIndexRouteImport } from './routes/w/$slug/machines/index'
import { Route as WSlugMachinesNewRouteImport } from './routes/w/$slug/machines/new'
import { Route as WSlugMaterialsIndexRouteImport } from './routes/w/$slug/materials/index'
import { Route as WSlugProductsIndexRouteImport } from './routes/w/$slug/products/index'
import { Route as WSlugProductsNewRouteImport } from './routes/w/$slug/products/new'
import { Route as WSlugReportsMonthlyRouteImport } from './routes/w/$slug/reports/monthly'
import { Route as WSlugReturnsIndexRouteImport } from './routes/w/$slug/returns/index'
import { Route as WSlugReturnsNewRouteImport } from './routes/w/$slug/returns/new'
import { Route as WSlugSalesReportsIndexRouteImport } from './routes/w/$slug/sales-reports/index'
import { Route as WSlugSalesReportsNewRouteImport } from './routes/w/$slug/sales-reports/new'
import { Route as WSlugSalesReportsOutstandingRouteImport } from './routes/w/$slug/sales-reports/outstanding'
import { Route as WSlugSettingsCogsRouteImport } from './routes/w/$slug/settings/cogs'
import { Route as WSlugSettingsExpenseCategoriesRouteImport } from './routes/w/$slug/settings/expense-categories'
import { Route as WSlugSettingsUsersRouteImport } from './routes/w/$slug/settings/users'
import { Route as WSlugSettingsWorkspaceRouteImport } from './routes/w/$slug/settings/workspace'
import { Route as WSlugStockIndexRouteImport } from './routes/w/$slug/stock/index'
import { Route as WSlugStockMovementsRouteImport } from './routes/w/$slug/stock/movements'
import { Route as WSlugStockWipRouteImport } from './routes/w/$slug/stock/wip'
import { Route as WSlugVendorPricesIndexRouteImport } from './routes/w/$slug/vendor-prices/index'
import { Route as WSlugAdjustmentsAdjustmentIdIndexRouteImport } from './routes/w/$slug/adjustments/$adjustmentId/index'
import { Route as WSlugAssembliesAssemblyIdIndexRouteImport } from './routes/w/$slug/assemblies/$assemblyId/index'
import { Route as WSlugBatchesBatchIdIndexRouteImport } from './routes/w/$slug/batches/$batchId/index'
import { Route as WSlugBatchesBatchIdCompleteRouteImport } from './routes/w/$slug/batches/$batchId/complete'
import { Route as WSlugChannelsChannelIdIndexRouteImport } from './routes/w/$slug/channels/$channelId/index'
import { Route as WSlugChannelsChannelIdEditRouteImport } from './routes/w/$slug/channels/$channelId/edit'
import { Route as WSlugDispatchesDispatchIdIndexRouteImport } from './routes/w/$slug/dispatches/$dispatchId/index'
import { Route as WSlugDispatchesDispatchIdPrintRouteImport } from './routes/w/$slug/dispatches/$dispatchId/print'
import { Route as WSlugExpensesExpenseIdEditRouteImport } from './routes/w/$slug/expenses/$expenseId/edit'
import { Route as WSlugMachinesMachineIdIndexRouteImport } from './routes/w/$slug/machines/$machineId/index'
import { Route as WSlugMachinesMachineIdEditRouteImport } from './routes/w/$slug/machines/$machineId/edit'
import { Route as WSlugMaterialsPoolsNewRouteImport } from './routes/w/$slug/materials/pools/new'
import { Route as WSlugMaterialsRestocksIndexRouteImport } from './routes/w/$slug/materials/restocks/index'
import { Route as WSlugMaterialsRestocksNewRouteImport } from './routes/w/$slug/materials/restocks/new'
import { Route as WSlugProductsProductIdIndexRouteImport } from './routes/w/$slug/products/$productId/index'
import { Route as WSlugProductsProductIdBomRouteImport } from './routes/w/$slug/products/$productId/bom'
import { Route as WSlugProductsProductIdEditRouteImport } from './routes/w/$slug/products/$productId/edit'
import { Route as WSlugReturnsReturnIdIndexRouteImport } from './routes/w/$slug/returns/$returnId/index'
import { Route as WSlugSalesReportsReportIdIndexRouteImport } from './routes/w/$slug/sales-reports/$reportId/index'
import { Route as WSlugSettingsOpeningBalancesIndexRouteImport } from './routes/w/$slug/settings/opening-balances/index'
import { Route as WSlugSettingsOpeningBalancesNewRouteImport } from './routes/w/$slug/settings/opening-balances/new'
import { Route as WSlugVariantsVariantIdIndexRouteImport } from './routes/w/$slug/variants/$variantId/index'
import { Route as WSlugVariantsVariantIdEditRouteImport } from './routes/w/$slug/variants/$variantId/edit'
import { Route as WSlugMaterialsPoolsPoolIdIndexRouteImport } from './routes/w/$slug/materials/pools/$poolId/index'
import { Route as WSlugMaterialsPoolsPoolIdEditRouteImport } from './routes/w/$slug/materials/pools/$poolId/edit'
import { Route as WSlugMaterialsRestocksRestockIdIndexRouteImport } from './routes/w/$slug/materials/restocks/$restockId/index'
import { Route as WSlugProductsProductIdVariantsNewRouteImport } from './routes/w/$slug/products/$productId/variants/new'
import { Route as WSlugSettingsOpeningBalancesOpeningBalanceIdIndexRouteImport } from './routes/w/$slug/settings/opening-balances/$openingBalanceId/index'
import { Route as WSlugProductsProductIdModelsModelIdIndexRouteImport } from './routes/w/$slug/products/$productId/models/$modelId/index'
import { Route as WSlugProductsProductIdModelsModelIdVersionsVersionNoRouteImport } from './routes/w/$slug/products/$productId/models/$modelId/versions/$versionNo'
import { Route as WSlugProductsProductIdModelsModelIdVersionsNewRouteImport } from './routes/w/$slug/products/$productId/models/$modelId/versions/new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const Sign_upRoute = Sign_upRouteImport.update({
  id: '/sign_up',
  path: '/sign_up',
  getParentRoute: () => rootRouteImport,
} as any)
const WSlugRouteRoute = WSlugRouteRouteImport.update({
  id: '/w/$slug',
  path: '/w/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const WSlugIndexRoute = WSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugAccountRoute = WSlugAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugWelcomeRoute = WSlugWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugAdjustmentsIndexRoute = WSlugAdjustmentsIndexRouteImport.update({
  id: '/adjustments/',
  path: '/adjustments/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugAdjustmentsNewRoute = WSlugAdjustmentsNewRouteImport.update({
  id: '/adjustments/new',
  path: '/adjustments/new',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugAssembliesIndexRoute = WSlugAssembliesIndexRouteImport.update({
  id: '/assemblies/',
  path: '/assemblies/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugAssembliesNewRoute = WSlugAssembliesNewRouteImport.update({
  id: '/assemblies/new',
  path: '/assemblies/new',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugBatchesIndexRoute = WSlugBatchesIndexRouteImport.update({
  id: '/batches/',
  path: '/batches/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugBatchesNewRoute = WSlugBatchesNewRouteImport.update({
  id: '/batches/new',
  path: '/batches/new',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugChannelsIndexRoute = WSlugChannelsIndexRouteImport.update({
  id: '/channels/',
  path: '/channels/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugChannelsNewRoute = WSlugChannelsNewRouteImport.update({
  id: '/channels/new',
  path: '/channels/new',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugCogsIndexRoute = WSlugCogsIndexRouteImport.update({
  id: '/cogs/',
  path: '/cogs/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugCogsVariantIdRoute = WSlugCogsVariantIdRouteImport.update({
  id: '/cogs/$variantId',
  path: '/cogs/$variantId',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugDispatchesIndexRoute = WSlugDispatchesIndexRouteImport.update({
  id: '/dispatches/',
  path: '/dispatches/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugDispatchesNewRoute = WSlugDispatchesNewRouteImport.update({
  id: '/dispatches/new',
  path: '/dispatches/new',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugExpensesIndexRoute = WSlugExpensesIndexRouteImport.update({
  id: '/expenses/',
  path: '/expenses/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugExpensesNewRoute = WSlugExpensesNewRouteImport.update({
  id: '/expenses/new',
  path: '/expenses/new',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugGuideIndexRoute = WSlugGuideIndexRouteImport.update({
  id: '/guide/',
  path: '/guide/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugGuideMcpRoute = WSlugGuideMcpRouteImport.update({
  id: '/guide/mcp',
  path: '/guide/mcp',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugMachinesIndexRoute = WSlugMachinesIndexRouteImport.update({
  id: '/machines/',
  path: '/machines/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugMachinesNewRoute = WSlugMachinesNewRouteImport.update({
  id: '/machines/new',
  path: '/machines/new',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugMaterialsIndexRoute = WSlugMaterialsIndexRouteImport.update({
  id: '/materials/',
  path: '/materials/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugProductsIndexRoute = WSlugProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugProductsNewRoute = WSlugProductsNewRouteImport.update({
  id: '/products/new',
  path: '/products/new',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugReportsMonthlyRoute = WSlugReportsMonthlyRouteImport.update({
  id: '/reports/monthly',
  path: '/reports/monthly',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugReturnsIndexRoute = WSlugReturnsIndexRouteImport.update({
  id: '/returns/',
  path: '/returns/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugReturnsNewRoute = WSlugReturnsNewRouteImport.update({
  id: '/returns/new',
  path: '/returns/new',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugSalesReportsIndexRoute = WSlugSalesReportsIndexRouteImport.update({
  id: '/sales-reports/',
  path: '/sales-reports/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugSalesReportsNewRoute = WSlugSalesReportsNewRouteImport.update({
  id: '/sales-reports/new',
  path: '/sales-reports/new',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugSalesReportsOutstandingRoute =
  WSlugSalesReportsOutstandingRouteImport.update({
    id: '/sales-reports/outstanding',
    path: '/sales-reports/outstanding',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugSettingsCogsRoute = WSlugSettingsCogsRouteImport.update({
  id: '/settings/cogs',
  path: '/settings/cogs',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugSettingsExpenseCategoriesRoute =
  WSlugSettingsExpenseCategoriesRouteImport.update({
    id: '/settings/expense-categories',
    path: '/settings/expense-categories',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugSettingsUsersRoute = WSlugSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugSettingsWorkspaceRoute = WSlugSettingsWorkspaceRouteImport.update({
  id: '/settings/workspace',
  path: '/settings/workspace',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugStockIndexRoute = WSlugStockIndexRouteImport.update({
  id: '/stock/',
  path: '/stock/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugStockMovementsRoute = WSlugStockMovementsRouteImport.update({
  id: '/stock/movements',
  path: '/stock/movements',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugStockWipRoute = WSlugStockWipRouteImport.update({
  id: '/stock/wip',
  path: '/stock/wip',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugVendorPricesIndexRoute = WSlugVendorPricesIndexRouteImport.update({
  id: '/vendor-prices/',
  path: '/vendor-prices/',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugAdjustmentsAdjustmentIdIndexRoute =
  WSlugAdjustmentsAdjustmentIdIndexRouteImport.update({
    id: '/adjustments/$adjustmentId/',
    path: '/adjustments/$adjustmentId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugAssembliesAssemblyIdIndexRoute =
  WSlugAssembliesAssemblyIdIndexRouteImport.update({
    id: '/assemblies/$assemblyId/',
    path: '/assemblies/$assemblyId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugBatchesBatchIdIndexRoute =
  WSlugBatchesBatchIdIndexRouteImport.update({
    id: '/batches/$batchId/',
    path: '/batches/$batchId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugBatchesBatchIdCompleteRoute =
  WSlugBatchesBatchIdCompleteRouteImport.update({
    id: '/batches/$batchId/complete',
    path: '/batches/$batchId/complete',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugChannelsChannelIdIndexRoute =
  WSlugChannelsChannelIdIndexRouteImport.update({
    id: '/channels/$channelId/',
    path: '/channels/$channelId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugChannelsChannelIdEditRoute =
  WSlugChannelsChannelIdEditRouteImport.update({
    id: '/channels/$channelId/edit',
    path: '/channels/$channelId/edit',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugDispatchesDispatchIdIndexRoute =
  WSlugDispatchesDispatchIdIndexRouteImport.update({
    id: '/dispatches/$dispatchId/',
    path: '/dispatches/$dispatchId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugDispatchesDispatchIdPrintRoute =
  WSlugDispatchesDispatchIdPrintRouteImport.update({
    id: '/dispatches/$dispatchId/print',
    path: '/dispatches/$dispatchId/print',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugExpensesExpenseIdEditRoute =
  WSlugExpensesExpenseIdEditRouteImport.update({
    id: '/expenses/$expenseId/edit',
    path: '/expenses/$expenseId/edit',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugMachinesMachineIdIndexRoute =
  WSlugMachinesMachineIdIndexRouteImport.update({
    id: '/machines/$machineId/',
    path: '/machines/$machineId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugMachinesMachineIdEditRoute =
  WSlugMachinesMachineIdEditRouteImport.update({
    id: '/machines/$machineId/edit',
    path: '/machines/$machineId/edit',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugMaterialsPoolsNewRoute = WSlugMaterialsPoolsNewRouteImport.update({
  id: '/materials/pools/new',
  path: '/materials/pools/new',
  getParentRoute: () => WSlugRouteRoute,
} as any)
const WSlugMaterialsRestocksIndexRoute =
  WSlugMaterialsRestocksIndexRouteImport.update({
    id: '/materials/restocks/',
    path: '/materials/restocks/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugMaterialsRestocksNewRoute =
  WSlugMaterialsRestocksNewRouteImport.update({
    id: '/materials/restocks/new',
    path: '/materials/restocks/new',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugProductsProductIdIndexRoute =
  WSlugProductsProductIdIndexRouteImport.update({
    id: '/products/$productId/',
    path: '/products/$productId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugProductsProductIdBomRoute =
  WSlugProductsProductIdBomRouteImport.update({
    id: '/products/$productId/bom',
    path: '/products/$productId/bom',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugProductsProductIdEditRoute =
  WSlugProductsProductIdEditRouteImport.update({
    id: '/products/$productId/edit',
    path: '/products/$productId/edit',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugReturnsReturnIdIndexRoute =
  WSlugReturnsReturnIdIndexRouteImport.update({
    id: '/returns/$returnId/',
    path: '/returns/$returnId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugSalesReportsReportIdIndexRoute =
  WSlugSalesReportsReportIdIndexRouteImport.update({
    id: '/sales-reports/$reportId/',
    path: '/sales-reports/$reportId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugSettingsOpeningBalancesIndexRoute =
  WSlugSettingsOpeningBalancesIndexRouteImport.update({
    id: '/settings/opening-balances/',
    path: '/settings/opening-balances/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugSettingsOpeningBalancesNewRoute =
  WSlugSettingsOpeningBalancesNewRouteImport.update({
    id: '/settings/opening-balances/new',
    path: '/settings/opening-balances/new',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugVariantsVariantIdIndexRoute =
  WSlugVariantsVariantIdIndexRouteImport.update({
    id: '/variants/$variantId/',
    path: '/variants/$variantId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugVariantsVariantIdEditRoute =
  WSlugVariantsVariantIdEditRouteImport.update({
    id: '/variants/$variantId/edit',
    path: '/variants/$variantId/edit',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugMaterialsPoolsPoolIdIndexRoute =
  WSlugMaterialsPoolsPoolIdIndexRouteImport.update({
    id: '/materials/pools/$poolId/',
    path: '/materials/pools/$poolId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugMaterialsPoolsPoolIdEditRoute =
  WSlugMaterialsPoolsPoolIdEditRouteImport.update({
    id: '/materials/pools/$poolId/edit',
    path: '/materials/pools/$poolId/edit',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugMaterialsRestocksRestockIdIndexRoute =
  WSlugMaterialsRestocksRestockIdIndexRouteImport.update({
    id: '/materials/restocks/$restockId/',
    path: '/materials/restocks/$restockId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugProductsProductIdVariantsNewRoute =
  WSlugProductsProductIdVariantsNewRouteImport.update({
    id: '/products/$productId/variants/new',
    path: '/products/$productId/variants/new',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugSettingsOpeningBalancesOpeningBalanceIdIndexRoute =
  WSlugSettingsOpeningBalancesOpeningBalanceIdIndexRouteImport.update({
    id: '/settings/opening-balances/$openingBalanceId/',
    path: '/settings/opening-balances/$openingBalanceId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugProductsProductIdModelsModelIdIndexRoute =
  WSlugProductsProductIdModelsModelIdIndexRouteImport.update({
    id: '/products/$productId/models/$modelId/',
    path: '/products/$productId/models/$modelId/',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugProductsProductIdModelsModelIdVersionsVersionNoRoute =
  WSlugProductsProductIdModelsModelIdVersionsVersionNoRouteImport.update({
    id: '/products/$productId/models/$modelId/versions/$versionNo',
    path: '/products/$productId/models/$modelId/versions/$versionNo',
    getParentRoute: () => WSlugRouteRoute,
  } as any)
const WSlugProductsProductIdModelsModelIdVersionsNewRoute =
  WSlugProductsProductIdModelsModelIdVersionsNewRouteImport.update({
    id: '/products/$productId/models/$modelId/versions/new',
    path: '/products/$productId/models/$modelId/versions/new',
    getParentRoute: () => WSlugRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/sign_up': typeof Sign_upRoute
  '/w/$slug': typeof WSlugRouteRouteWithChildren
  '/w/$slug/account': typeof WSlugAccountRoute
  '/w/$slug/welcome': typeof WSlugWelcomeRoute
  '/w/$slug/': typeof WSlugIndexRoute
  '/w/$slug/adjustments/new': typeof WSlugAdjustmentsNewRoute
  '/w/$slug/assemblies/new': typeof WSlugAssembliesNewRoute
  '/w/$slug/batches/new': typeof WSlugBatchesNewRoute
  '/w/$slug/channels/new': typeof WSlugChannelsNewRoute
  '/w/$slug/cogs/$variantId': typeof WSlugCogsVariantIdRoute
  '/w/$slug/dispatches/new': typeof WSlugDispatchesNewRoute
  '/w/$slug/expenses/new': typeof WSlugExpensesNewRoute
  '/w/$slug/guide/mcp': typeof WSlugGuideMcpRoute
  '/w/$slug/machines/new': typeof WSlugMachinesNewRoute
  '/w/$slug/products/new': typeof WSlugProductsNewRoute
  '/w/$slug/reports/monthly': typeof WSlugReportsMonthlyRoute
  '/w/$slug/returns/new': typeof WSlugReturnsNewRoute
  '/w/$slug/sales-reports/new': typeof WSlugSalesReportsNewRoute
  '/w/$slug/sales-reports/outstanding': typeof WSlugSalesReportsOutstandingRoute
  '/w/$slug/settings/cogs': typeof WSlugSettingsCogsRoute
  '/w/$slug/settings/expense-categories': typeof WSlugSettingsExpenseCategoriesRoute
  '/w/$slug/settings/users': typeof WSlugSettingsUsersRoute
  '/w/$slug/settings/workspace': typeof WSlugSettingsWorkspaceRoute
  '/w/$slug/stock/movements': typeof WSlugStockMovementsRoute
  '/w/$slug/stock/wip': typeof WSlugStockWipRoute
  '/w/$slug/adjustments/': typeof WSlugAdjustmentsIndexRoute
  '/w/$slug/assemblies/': typeof WSlugAssembliesIndexRoute
  '/w/$slug/batches/': typeof WSlugBatchesIndexRoute
  '/w/$slug/channels/': typeof WSlugChannelsIndexRoute
  '/w/$slug/cogs/': typeof WSlugCogsIndexRoute
  '/w/$slug/dispatches/': typeof WSlugDispatchesIndexRoute
  '/w/$slug/expenses/': typeof WSlugExpensesIndexRoute
  '/w/$slug/guide/': typeof WSlugGuideIndexRoute
  '/w/$slug/machines/': typeof WSlugMachinesIndexRoute
  '/w/$slug/materials/': typeof WSlugMaterialsIndexRoute
  '/w/$slug/products/': typeof WSlugProductsIndexRoute
  '/w/$slug/returns/': typeof WSlugReturnsIndexRoute
  '/w/$slug/sales-reports/': typeof WSlugSalesReportsIndexRoute
  '/w/$slug/stock/': typeof WSlugStockIndexRoute
  '/w/$slug/vendor-prices/': typeof WSlugVendorPricesIndexRoute
  '/w/$slug/batches/$batchId/complete': typeof WSlugBatchesBatchIdCompleteRoute
  '/w/$slug/channels/$channelId/edit': typeof WSlugChannelsChannelIdEditRoute
  '/w/$slug/dispatches/$dispatchId/print': typeof WSlugDispatchesDispatchIdPrintRoute
  '/w/$slug/expenses/$expenseId/edit': typeof WSlugExpensesExpenseIdEditRoute
  '/w/$slug/machines/$machineId/edit': typeof WSlugMachinesMachineIdEditRoute
  '/w/$slug/materials/pools/new': typeof WSlugMaterialsPoolsNewRoute
  '/w/$slug/materials/restocks/new': typeof WSlugMaterialsRestocksNewRoute
  '/w/$slug/products/$productId/bom': typeof WSlugProductsProductIdBomRoute
  '/w/$slug/products/$productId/edit': typeof WSlugProductsProductIdEditRoute
  '/w/$slug/settings/opening-balances/new': typeof WSlugSettingsOpeningBalancesNewRoute
  '/w/$slug/variants/$variantId/edit': typeof WSlugVariantsVariantIdEditRoute
  '/w/$slug/adjustments/$adjustmentId/': typeof WSlugAdjustmentsAdjustmentIdIndexRoute
  '/w/$slug/assemblies/$assemblyId/': typeof WSlugAssembliesAssemblyIdIndexRoute
  '/w/$slug/batches/$batchId/': typeof WSlugBatchesBatchIdIndexRoute
  '/w/$slug/channels/$channelId/': typeof WSlugChannelsChannelIdIndexRoute
  '/w/$slug/dispatches/$dispatchId/': typeof WSlugDispatchesDispatchIdIndexRoute
  '/w/$slug/machines/$machineId/': typeof WSlugMachinesMachineIdIndexRoute
  '/w/$slug/materials/restocks/': typeof WSlugMaterialsRestocksIndexRoute
  '/w/$slug/products/$productId/': typeof WSlugProductsProductIdIndexRoute
  '/w/$slug/returns/$returnId/': typeof WSlugReturnsReturnIdIndexRoute
  '/w/$slug/sales-reports/$reportId/': typeof WSlugSalesReportsReportIdIndexRoute
  '/w/$slug/settings/opening-balances/': typeof WSlugSettingsOpeningBalancesIndexRoute
  '/w/$slug/variants/$variantId/': typeof WSlugVariantsVariantIdIndexRoute
  '/w/$slug/materials/pools/$poolId/edit': typeof WSlugMaterialsPoolsPoolIdEditRoute
  '/w/$slug/products/$productId/variants/new': typeof WSlugProductsProductIdVariantsNewRoute
  '/w/$slug/materials/pools/$poolId/': typeof WSlugMaterialsPoolsPoolIdIndexRoute
  '/w/$slug/materials/restocks/$restockId/': typeof WSlugMaterialsRestocksRestockIdIndexRoute
  '/w/$slug/settings/opening-balances/$openingBalanceId/': typeof WSlugSettingsOpeningBalancesOpeningBalanceIdIndexRoute
  '/w/$slug/products/$productId/models/$modelId/': typeof WSlugProductsProductIdModelsModelIdIndexRoute
  '/w/$slug/products/$productId/models/$modelId/versions/$versionNo': typeof WSlugProductsProductIdModelsModelIdVersionsVersionNoRoute
  '/w/$slug/products/$productId/models/$modelId/versions/new': typeof WSlugProductsProductIdModelsModelIdVersionsNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/sign_up': typeof Sign_upRoute
  '/w/$slug/account': typeof WSlugAccountRoute
  '/w/$slug/welcome': typeof WSlugWelcomeRoute
  '/w/$slug': typeof WSlugIndexRoute
  '/w/$slug/adjustments/new': typeof WSlugAdjustmentsNewRoute
  '/w/$slug/assemblies/new': typeof WSlugAssembliesNewRoute
  '/w/$slug/batches/new': typeof WSlugBatchesNewRoute
  '/w/$slug/channels/new': typeof WSlugChannelsNewRoute
  '/w/$slug/cogs/$variantId': typeof WSlugCogsVariantIdRoute
  '/w/$slug/dispatches/new': typeof WSlugDispatchesNewRoute
  '/w/$slug/expenses/new': typeof WSlugExpensesNewRoute
  '/w/$slug/guide/mcp': typeof WSlugGuideMcpRoute
  '/w/$slug/machines/new': typeof WSlugMachinesNewRoute
  '/w/$slug/products/new': typeof WSlugProductsNewRoute
  '/w/$slug/reports/monthly': typeof WSlugReportsMonthlyRoute
  '/w/$slug/returns/new': typeof WSlugReturnsNewRoute
  '/w/$slug/sales-reports/new': typeof WSlugSalesReportsNewRoute
  '/w/$slug/sales-reports/outstanding': typeof WSlugSalesReportsOutstandingRoute
  '/w/$slug/settings/cogs': typeof WSlugSettingsCogsRoute
  '/w/$slug/settings/expense-categories': typeof WSlugSettingsExpenseCategoriesRoute
  '/w/$slug/settings/users': typeof WSlugSettingsUsersRoute
  '/w/$slug/settings/workspace': typeof WSlugSettingsWorkspaceRoute
  '/w/$slug/stock/movements': typeof WSlugStockMovementsRoute
  '/w/$slug/stock/wip': typeof WSlugStockWipRoute
  '/w/$slug/adjustments': typeof WSlugAdjustmentsIndexRoute
  '/w/$slug/assemblies': typeof WSlugAssembliesIndexRoute
  '/w/$slug/batches': typeof WSlugBatchesIndexRoute
  '/w/$slug/channels': typeof WSlugChannelsIndexRoute
  '/w/$slug/cogs': typeof WSlugCogsIndexRoute
  '/w/$slug/dispatches': typeof WSlugDispatchesIndexRoute
  '/w/$slug/expenses': typeof WSlugExpensesIndexRoute
  '/w/$slug/guide': typeof WSlugGuideIndexRoute
  '/w/$slug/machines': typeof WSlugMachinesIndexRoute
  '/w/$slug/materials': typeof WSlugMaterialsIndexRoute
  '/w/$slug/products': typeof WSlugProductsIndexRoute
  '/w/$slug/returns': typeof WSlugReturnsIndexRoute
  '/w/$slug/sales-reports': typeof WSlugSalesReportsIndexRoute
  '/w/$slug/stock': typeof WSlugStockIndexRoute
  '/w/$slug/vendor-prices': typeof WSlugVendorPricesIndexRoute
  '/w/$slug/batches/$batchId/complete': typeof WSlugBatchesBatchIdCompleteRoute
  '/w/$slug/channels/$channelId/edit': typeof WSlugChannelsChannelIdEditRoute
  '/w/$slug/dispatches/$dispatchId/print': typeof WSlugDispatchesDispatchIdPrintRoute
  '/w/$slug/expenses/$expenseId/edit': typeof WSlugExpensesExpenseIdEditRoute
  '/w/$slug/machines/$machineId/edit': typeof WSlugMachinesMachineIdEditRoute
  '/w/$slug/materials/pools/new': typeof WSlugMaterialsPoolsNewRoute
  '/w/$slug/materials/restocks/new': typeof WSlugMaterialsRestocksNewRoute
  '/w/$slug/products/$productId/bom': typeof WSlugProductsProductIdBomRoute
  '/w/$slug/products/$productId/edit': typeof WSlugProductsProductIdEditRoute
  '/w/$slug/settings/opening-balances/new': typeof WSlugSettingsOpeningBalancesNewRoute
  '/w/$slug/variants/$variantId/edit': typeof WSlugVariantsVariantIdEditRoute
  '/w/$slug/adjustments/$adjustmentId': typeof WSlugAdjustmentsAdjustmentIdIndexRoute
  '/w/$slug/assemblies/$assemblyId': typeof WSlugAssembliesAssemblyIdIndexRoute
  '/w/$slug/batches/$batchId': typeof WSlugBatchesBatchIdIndexRoute
  '/w/$slug/channels/$channelId': typeof WSlugChannelsChannelIdIndexRoute
  '/w/$slug/dispatches/$dispatchId': typeof WSlugDispatchesDispatchIdIndexRoute
  '/w/$slug/machines/$machineId': typeof WSlugMachinesMachineIdIndexRoute
  '/w/$slug/materials/restocks': typeof WSlugMaterialsRestocksIndexRoute
  '/w/$slug/products/$productId': typeof WSlugProductsProductIdIndexRoute
  '/w/$slug/returns/$returnId': typeof WSlugReturnsReturnIdIndexRoute
  '/w/$slug/sales-reports/$reportId': typeof WSlugSalesReportsReportIdIndexRoute
  '/w/$slug/settings/opening-balances': typeof WSlugSettingsOpeningBalancesIndexRoute
  '/w/$slug/variants/$variantId': typeof WSlugVariantsVariantIdIndexRoute
  '/w/$slug/materials/pools/$poolId/edit': typeof WSlugMaterialsPoolsPoolIdEditRoute
  '/w/$slug/products/$productId/variants/new': typeof WSlugProductsProductIdVariantsNewRoute
  '/w/$slug/materials/pools/$poolId': typeof WSlugMaterialsPoolsPoolIdIndexRoute
  '/w/$slug/materials/restocks/$restockId': typeof WSlugMaterialsRestocksRestockIdIndexRoute
  '/w/$slug/settings/opening-balances/$openingBalanceId': typeof WSlugSettingsOpeningBalancesOpeningBalanceIdIndexRoute
  '/w/$slug/products/$productId/models/$modelId': typeof WSlugProductsProductIdModelsModelIdIndexRoute
  '/w/$slug/products/$productId/models/$modelId/versions/$versionNo': typeof WSlugProductsProductIdModelsModelIdVersionsVersionNoRoute
  '/w/$slug/products/$productId/models/$modelId/versions/new': typeof WSlugProductsProductIdModelsModelIdVersionsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/sign_up': typeof Sign_upRoute
  '/w/$slug': typeof WSlugRouteRouteWithChildren
  '/w/$slug/account': typeof WSlugAccountRoute
  '/w/$slug/welcome': typeof WSlugWelcomeRoute
  '/w/$slug/': typeof WSlugIndexRoute
  '/w/$slug/adjustments/new': typeof WSlugAdjustmentsNewRoute
  '/w/$slug/assemblies/new': typeof WSlugAssembliesNewRoute
  '/w/$slug/batches/new': typeof WSlugBatchesNewRoute
  '/w/$slug/channels/new': typeof WSlugChannelsNewRoute
  '/w/$slug/cogs/$variantId': typeof WSlugCogsVariantIdRoute
  '/w/$slug/dispatches/new': typeof WSlugDispatchesNewRoute
  '/w/$slug/expenses/new': typeof WSlugExpensesNewRoute
  '/w/$slug/guide/mcp': typeof WSlugGuideMcpRoute
  '/w/$slug/machines/new': typeof WSlugMachinesNewRoute
  '/w/$slug/products/new': typeof WSlugProductsNewRoute
  '/w/$slug/reports/monthly': typeof WSlugReportsMonthlyRoute
  '/w/$slug/returns/new': typeof WSlugReturnsNewRoute
  '/w/$slug/sales-reports/new': typeof WSlugSalesReportsNewRoute
  '/w/$slug/sales-reports/outstanding': typeof WSlugSalesReportsOutstandingRoute
  '/w/$slug/settings/cogs': typeof WSlugSettingsCogsRoute
  '/w/$slug/settings/expense-categories': typeof WSlugSettingsExpenseCategoriesRoute
  '/w/$slug/settings/users': typeof WSlugSettingsUsersRoute
  '/w/$slug/settings/workspace': typeof WSlugSettingsWorkspaceRoute
  '/w/$slug/stock/movements': typeof WSlugStockMovementsRoute
  '/w/$slug/stock/wip': typeof WSlugStockWipRoute
  '/w/$slug/adjustments/': typeof WSlugAdjustmentsIndexRoute
  '/w/$slug/assemblies/': typeof WSlugAssembliesIndexRoute
  '/w/$slug/batches/': typeof WSlugBatchesIndexRoute
  '/w/$slug/channels/': typeof WSlugChannelsIndexRoute
  '/w/$slug/cogs/': typeof WSlugCogsIndexRoute
  '/w/$slug/dispatches/': typeof WSlugDispatchesIndexRoute
  '/w/$slug/expenses/': typeof WSlugExpensesIndexRoute
  '/w/$slug/guide/': typeof WSlugGuideIndexRoute
  '/w/$slug/machines/': typeof WSlugMachinesIndexRoute
  '/w/$slug/materials/': typeof WSlugMaterialsIndexRoute
  '/w/$slug/products/': typeof WSlugProductsIndexRoute
  '/w/$slug/returns/': typeof WSlugReturnsIndexRoute
  '/w/$slug/sales-reports/': typeof WSlugSalesReportsIndexRoute
  '/w/$slug/stock/': typeof WSlugStockIndexRoute
  '/w/$slug/vendor-prices/': typeof WSlugVendorPricesIndexRoute
  '/w/$slug/batches/$batchId/complete': typeof WSlugBatchesBatchIdCompleteRoute
  '/w/$slug/channels/$channelId/edit': typeof WSlugChannelsChannelIdEditRoute
  '/w/$slug/dispatches/$dispatchId/print': typeof WSlugDispatchesDispatchIdPrintRoute
  '/w/$slug/expenses/$expenseId/edit': typeof WSlugExpensesExpenseIdEditRoute
  '/w/$slug/machines/$machineId/edit': typeof WSlugMachinesMachineIdEditRoute
  '/w/$slug/materials/pools/new': typeof WSlugMaterialsPoolsNewRoute
  '/w/$slug/materials/restocks/new': typeof WSlugMaterialsRestocksNewRoute
  '/w/$slug/products/$productId/bom': typeof WSlugProductsProductIdBomRoute
  '/w/$slug/products/$productId/edit': typeof WSlugProductsProductIdEditRoute
  '/w/$slug/settings/opening-balances/new': typeof WSlugSettingsOpeningBalancesNewRoute
  '/w/$slug/variants/$variantId/edit': typeof WSlugVariantsVariantIdEditRoute
  '/w/$slug/adjustments/$adjustmentId/': typeof WSlugAdjustmentsAdjustmentIdIndexRoute
  '/w/$slug/assemblies/$assemblyId/': typeof WSlugAssembliesAssemblyIdIndexRoute
  '/w/$slug/batches/$batchId/': typeof WSlugBatchesBatchIdIndexRoute
  '/w/$slug/channels/$channelId/': typeof WSlugChannelsChannelIdIndexRoute
  '/w/$slug/dispatches/$dispatchId/': typeof WSlugDispatchesDispatchIdIndexRoute
  '/w/$slug/machines/$machineId/': typeof WSlugMachinesMachineIdIndexRoute
  '/w/$slug/materials/restocks/': typeof WSlugMaterialsRestocksIndexRoute
  '/w/$slug/products/$productId/': typeof WSlugProductsProductIdIndexRoute
  '/w/$slug/returns/$returnId/': typeof WSlugReturnsReturnIdIndexRoute
  '/w/$slug/sales-reports/$reportId/': typeof WSlugSalesReportsReportIdIndexRoute
  '/w/$slug/settings/opening-balances/': typeof WSlugSettingsOpeningBalancesIndexRoute
  '/w/$slug/variants/$variantId/': typeof WSlugVariantsVariantIdIndexRoute
  '/w/$slug/materials/pools/$poolId/edit': typeof WSlugMaterialsPoolsPoolIdEditRoute
  '/w/$slug/products/$productId/variants/new': typeof WSlugProductsProductIdVariantsNewRoute
  '/w/$slug/materials/pools/$poolId/': typeof WSlugMaterialsPoolsPoolIdIndexRoute
  '/w/$slug/materials/restocks/$restockId/': typeof WSlugMaterialsRestocksRestockIdIndexRoute
  '/w/$slug/settings/opening-balances/$openingBalanceId/': typeof WSlugSettingsOpeningBalancesOpeningBalanceIdIndexRoute
  '/w/$slug/products/$productId/models/$modelId/': typeof WSlugProductsProductIdModelsModelIdIndexRoute
  '/w/$slug/products/$productId/models/$modelId/versions/$versionNo': typeof WSlugProductsProductIdModelsModelIdVersionsVersionNoRoute
  '/w/$slug/products/$productId/models/$modelId/versions/new': typeof WSlugProductsProductIdModelsModelIdVersionsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/sign_up'
    | '/w/$slug'
    | '/w/$slug/account'
    | '/w/$slug/welcome'
    | '/w/$slug/'
    | '/w/$slug/adjustments/new'
    | '/w/$slug/assemblies/new'
    | '/w/$slug/batches/new'
    | '/w/$slug/channels/new'
    | '/w/$slug/cogs/$variantId'
    | '/w/$slug/dispatches/new'
    | '/w/$slug/expenses/new'
    | '/w/$slug/guide/mcp'
    | '/w/$slug/machines/new'
    | '/w/$slug/products/new'
    | '/w/$slug/reports/monthly'
    | '/w/$slug/returns/new'
    | '/w/$slug/sales-reports/new'
    | '/w/$slug/sales-reports/outstanding'
    | '/w/$slug/settings/cogs'
    | '/w/$slug/settings/expense-categories'
    | '/w/$slug/settings/users'
    | '/w/$slug/settings/workspace'
    | '/w/$slug/stock/movements'
    | '/w/$slug/stock/wip'
    | '/w/$slug/adjustments/'
    | '/w/$slug/assemblies/'
    | '/w/$slug/batches/'
    | '/w/$slug/channels/'
    | '/w/$slug/cogs/'
    | '/w/$slug/dispatches/'
    | '/w/$slug/expenses/'
    | '/w/$slug/guide/'
    | '/w/$slug/machines/'
    | '/w/$slug/materials/'
    | '/w/$slug/products/'
    | '/w/$slug/returns/'
    | '/w/$slug/sales-reports/'
    | '/w/$slug/stock/'
    | '/w/$slug/vendor-prices/'
    | '/w/$slug/batches/$batchId/complete'
    | '/w/$slug/channels/$channelId/edit'
    | '/w/$slug/dispatches/$dispatchId/print'
    | '/w/$slug/expenses/$expenseId/edit'
    | '/w/$slug/machines/$machineId/edit'
    | '/w/$slug/materials/pools/new'
    | '/w/$slug/materials/restocks/new'
    | '/w/$slug/products/$productId/bom'
    | '/w/$slug/products/$productId/edit'
    | '/w/$slug/settings/opening-balances/new'
    | '/w/$slug/variants/$variantId/edit'
    | '/w/$slug/adjustments/$adjustmentId/'
    | '/w/$slug/assemblies/$assemblyId/'
    | '/w/$slug/batches/$batchId/'
    | '/w/$slug/channels/$channelId/'
    | '/w/$slug/dispatches/$dispatchId/'
    | '/w/$slug/machines/$machineId/'
    | '/w/$slug/materials/restocks/'
    | '/w/$slug/products/$productId/'
    | '/w/$slug/returns/$returnId/'
    | '/w/$slug/sales-reports/$reportId/'
    | '/w/$slug/settings/opening-balances/'
    | '/w/$slug/variants/$variantId/'
    | '/w/$slug/materials/pools/$poolId/edit'
    | '/w/$slug/products/$productId/variants/new'
    | '/w/$slug/materials/pools/$poolId/'
    | '/w/$slug/materials/restocks/$restockId/'
    | '/w/$slug/settings/opening-balances/$openingBalanceId/'
    | '/w/$slug/products/$productId/models/$modelId/'
    | '/w/$slug/products/$productId/models/$modelId/versions/$versionNo'
    | '/w/$slug/products/$productId/models/$modelId/versions/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/sign_up'
    | '/w/$slug/account'
    | '/w/$slug/welcome'
    | '/w/$slug'
    | '/w/$slug/adjustments/new'
    | '/w/$slug/assemblies/new'
    | '/w/$slug/batches/new'
    | '/w/$slug/channels/new'
    | '/w/$slug/cogs/$variantId'
    | '/w/$slug/dispatches/new'
    | '/w/$slug/expenses/new'
    | '/w/$slug/guide/mcp'
    | '/w/$slug/machines/new'
    | '/w/$slug/products/new'
    | '/w/$slug/reports/monthly'
    | '/w/$slug/returns/new'
    | '/w/$slug/sales-reports/new'
    | '/w/$slug/sales-reports/outstanding'
    | '/w/$slug/settings/cogs'
    | '/w/$slug/settings/expense-categories'
    | '/w/$slug/settings/users'
    | '/w/$slug/settings/workspace'
    | '/w/$slug/stock/movements'
    | '/w/$slug/stock/wip'
    | '/w/$slug/adjustments'
    | '/w/$slug/assemblies'
    | '/w/$slug/batches'
    | '/w/$slug/channels'
    | '/w/$slug/cogs'
    | '/w/$slug/dispatches'
    | '/w/$slug/expenses'
    | '/w/$slug/guide'
    | '/w/$slug/machines'
    | '/w/$slug/materials'
    | '/w/$slug/products'
    | '/w/$slug/returns'
    | '/w/$slug/sales-reports'
    | '/w/$slug/stock'
    | '/w/$slug/vendor-prices'
    | '/w/$slug/batches/$batchId/complete'
    | '/w/$slug/channels/$channelId/edit'
    | '/w/$slug/dispatches/$dispatchId/print'
    | '/w/$slug/expenses/$expenseId/edit'
    | '/w/$slug/machines/$machineId/edit'
    | '/w/$slug/materials/pools/new'
    | '/w/$slug/materials/restocks/new'
    | '/w/$slug/products/$productId/bom'
    | '/w/$slug/products/$productId/edit'
    | '/w/$slug/settings/opening-balances/new'
    | '/w/$slug/variants/$variantId/edit'
    | '/w/$slug/adjustments/$adjustmentId'
    | '/w/$slug/assemblies/$assemblyId'
    | '/w/$slug/batches/$batchId'
    | '/w/$slug/channels/$channelId'
    | '/w/$slug/dispatches/$dispatchId'
    | '/w/$slug/machines/$machineId'
    | '/w/$slug/materials/restocks'
    | '/w/$slug/products/$productId'
    | '/w/$slug/returns/$returnId'
    | '/w/$slug/sales-reports/$reportId'
    | '/w/$slug/settings/opening-balances'
    | '/w/$slug/variants/$variantId'
    | '/w/$slug/materials/pools/$poolId/edit'
    | '/w/$slug/products/$productId/variants/new'
    | '/w/$slug/materials/pools/$poolId'
    | '/w/$slug/materials/restocks/$restockId'
    | '/w/$slug/settings/opening-balances/$openingBalanceId'
    | '/w/$slug/products/$productId/models/$modelId'
    | '/w/$slug/products/$productId/models/$modelId/versions/$versionNo'
    | '/w/$slug/products/$productId/models/$modelId/versions/new'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/sign_up'
    | '/w/$slug'
    | '/w/$slug/account'
    | '/w/$slug/welcome'
    | '/w/$slug/'
    | '/w/$slug/adjustments/new'
    | '/w/$slug/assemblies/new'
    | '/w/$slug/batches/new'
    | '/w/$slug/channels/new'
    | '/w/$slug/cogs/$variantId'
    | '/w/$slug/dispatches/new'
    | '/w/$slug/expenses/new'
    | '/w/$slug/guide/mcp'
    | '/w/$slug/machines/new'
    | '/w/$slug/products/new'
    | '/w/$slug/reports/monthly'
    | '/w/$slug/returns/new'
    | '/w/$slug/sales-reports/new'
    | '/w/$slug/sales-reports/outstanding'
    | '/w/$slug/settings/cogs'
    | '/w/$slug/settings/expense-categories'
    | '/w/$slug/settings/users'
    | '/w/$slug/settings/workspace'
    | '/w/$slug/stock/movements'
    | '/w/$slug/stock/wip'
    | '/w/$slug/adjustments/'
    | '/w/$slug/assemblies/'
    | '/w/$slug/batches/'
    | '/w/$slug/channels/'
    | '/w/$slug/cogs/'
    | '/w/$slug/dispatches/'
    | '/w/$slug/expenses/'
    | '/w/$slug/guide/'
    | '/w/$slug/machines/'
    | '/w/$slug/materials/'
    | '/w/$slug/products/'
    | '/w/$slug/returns/'
    | '/w/$slug/sales-reports/'
    | '/w/$slug/stock/'
    | '/w/$slug/vendor-prices/'
    | '/w/$slug/batches/$batchId/complete'
    | '/w/$slug/channels/$channelId/edit'
    | '/w/$slug/dispatches/$dispatchId/print'
    | '/w/$slug/expenses/$expenseId/edit'
    | '/w/$slug/machines/$machineId/edit'
    | '/w/$slug/materials/pools/new'
    | '/w/$slug/materials/restocks/new'
    | '/w/$slug/products/$productId/bom'
    | '/w/$slug/products/$productId/edit'
    | '/w/$slug/settings/opening-balances/new'
    | '/w/$slug/variants/$variantId/edit'
    | '/w/$slug/adjustments/$adjustmentId/'
    | '/w/$slug/assemblies/$assemblyId/'
    | '/w/$slug/batches/$batchId/'
    | '/w/$slug/channels/$channelId/'
    | '/w/$slug/dispatches/$dispatchId/'
    | '/w/$slug/machines/$machineId/'
    | '/w/$slug/materials/restocks/'
    | '/w/$slug/products/$productId/'
    | '/w/$slug/returns/$returnId/'
    | '/w/$slug/sales-reports/$reportId/'
    | '/w/$slug/settings/opening-balances/'
    | '/w/$slug/variants/$variantId/'
    | '/w/$slug/materials/pools/$poolId/edit'
    | '/w/$slug/products/$productId/variants/new'
    | '/w/$slug/materials/pools/$poolId/'
    | '/w/$slug/materials/restocks/$restockId/'
    | '/w/$slug/settings/opening-balances/$openingBalanceId/'
    | '/w/$slug/products/$productId/models/$modelId/'
    | '/w/$slug/products/$productId/models/$modelId/versions/$versionNo'
    | '/w/$slug/products/$productId/models/$modelId/versions/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  Sign_upRoute: typeof Sign_upRoute
  WSlugRouteRoute: typeof WSlugRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign_up': {
      id: '/sign_up'
      path: '/sign_up'
      fullPath: '/sign_up'
      preLoaderRoute: typeof Sign_upRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$slug': {
      id: '/w/$slug'
      path: '/w/$slug'
      fullPath: '/w/$slug'
      preLoaderRoute: typeof WSlugRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$slug/': {
      id: '/w/$slug/'
      path: '/'
      fullPath: '/w/$slug/'
      preLoaderRoute: typeof WSlugIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/account': {
      id: '/w/$slug/account'
      path: '/account'
      fullPath: '/w/$slug/account'
      preLoaderRoute: typeof WSlugAccountRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/welcome': {
      id: '/w/$slug/welcome'
      path: '/welcome'
      fullPath: '/w/$slug/welcome'
      preLoaderRoute: typeof WSlugWelcomeRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/adjustments/': {
      id: '/w/$slug/adjustments/'
      path: '/adjustments'
      fullPath: '/w/$slug/adjustments/'
      preLoaderRoute: typeof WSlugAdjustmentsIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/adjustments/new': {
      id: '/w/$slug/adjustments/new'
      path: '/adjustments/new'
      fullPath: '/w/$slug/adjustments/new'
      preLoaderRoute: typeof WSlugAdjustmentsNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/assemblies/': {
      id: '/w/$slug/assemblies/'
      path: '/assemblies'
      fullPath: '/w/$slug/assemblies/'
      preLoaderRoute: typeof WSlugAssembliesIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/assemblies/new': {
      id: '/w/$slug/assemblies/new'
      path: '/assemblies/new'
      fullPath: '/w/$slug/assemblies/new'
      preLoaderRoute: typeof WSlugAssembliesNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/batches/': {
      id: '/w/$slug/batches/'
      path: '/batches'
      fullPath: '/w/$slug/batches/'
      preLoaderRoute: typeof WSlugBatchesIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/batches/new': {
      id: '/w/$slug/batches/new'
      path: '/batches/new'
      fullPath: '/w/$slug/batches/new'
      preLoaderRoute: typeof WSlugBatchesNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/channels/': {
      id: '/w/$slug/channels/'
      path: '/channels'
      fullPath: '/w/$slug/channels/'
      preLoaderRoute: typeof WSlugChannelsIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/channels/new': {
      id: '/w/$slug/channels/new'
      path: '/channels/new'
      fullPath: '/w/$slug/channels/new'
      preLoaderRoute: typeof WSlugChannelsNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/cogs/': {
      id: '/w/$slug/cogs/'
      path: '/cogs'
      fullPath: '/w/$slug/cogs/'
      preLoaderRoute: typeof WSlugCogsIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/cogs/$variantId': {
      id: '/w/$slug/cogs/$variantId'
      path: '/cogs/$variantId'
      fullPath: '/w/$slug/cogs/$variantId'
      preLoaderRoute: typeof WSlugCogsVariantIdRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/dispatches/': {
      id: '/w/$slug/dispatches/'
      path: '/dispatches'
      fullPath: '/w/$slug/dispatches/'
      preLoaderRoute: typeof WSlugDispatchesIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/dispatches/new': {
      id: '/w/$slug/dispatches/new'
      path: '/dispatches/new'
      fullPath: '/w/$slug/dispatches/new'
      preLoaderRoute: typeof WSlugDispatchesNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/expenses/': {
      id: '/w/$slug/expenses/'
      path: '/expenses'
      fullPath: '/w/$slug/expenses/'
      preLoaderRoute: typeof WSlugExpensesIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/expenses/new': {
      id: '/w/$slug/expenses/new'
      path: '/expenses/new'
      fullPath: '/w/$slug/expenses/new'
      preLoaderRoute: typeof WSlugExpensesNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/guide/': {
      id: '/w/$slug/guide/'
      path: '/guide'
      fullPath: '/w/$slug/guide/'
      preLoaderRoute: typeof WSlugGuideIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/guide/mcp': {
      id: '/w/$slug/guide/mcp'
      path: '/guide/mcp'
      fullPath: '/w/$slug/guide/mcp'
      preLoaderRoute: typeof WSlugGuideMcpRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/machines/': {
      id: '/w/$slug/machines/'
      path: '/machines'
      fullPath: '/w/$slug/machines/'
      preLoaderRoute: typeof WSlugMachinesIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/machines/new': {
      id: '/w/$slug/machines/new'
      path: '/machines/new'
      fullPath: '/w/$slug/machines/new'
      preLoaderRoute: typeof WSlugMachinesNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/materials/': {
      id: '/w/$slug/materials/'
      path: '/materials'
      fullPath: '/w/$slug/materials/'
      preLoaderRoute: typeof WSlugMaterialsIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/products/': {
      id: '/w/$slug/products/'
      path: '/products'
      fullPath: '/w/$slug/products/'
      preLoaderRoute: typeof WSlugProductsIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/products/new': {
      id: '/w/$slug/products/new'
      path: '/products/new'
      fullPath: '/w/$slug/products/new'
      preLoaderRoute: typeof WSlugProductsNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/reports/monthly': {
      id: '/w/$slug/reports/monthly'
      path: '/reports/monthly'
      fullPath: '/w/$slug/reports/monthly'
      preLoaderRoute: typeof WSlugReportsMonthlyRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/returns/': {
      id: '/w/$slug/returns/'
      path: '/returns'
      fullPath: '/w/$slug/returns/'
      preLoaderRoute: typeof WSlugReturnsIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/returns/new': {
      id: '/w/$slug/returns/new'
      path: '/returns/new'
      fullPath: '/w/$slug/returns/new'
      preLoaderRoute: typeof WSlugReturnsNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/sales-reports/': {
      id: '/w/$slug/sales-reports/'
      path: '/sales-reports'
      fullPath: '/w/$slug/sales-reports/'
      preLoaderRoute: typeof WSlugSalesReportsIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/sales-reports/new': {
      id: '/w/$slug/sales-reports/new'
      path: '/sales-reports/new'
      fullPath: '/w/$slug/sales-reports/new'
      preLoaderRoute: typeof WSlugSalesReportsNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/sales-reports/outstanding': {
      id: '/w/$slug/sales-reports/outstanding'
      path: '/sales-reports/outstanding'
      fullPath: '/w/$slug/sales-reports/outstanding'
      preLoaderRoute: typeof WSlugSalesReportsOutstandingRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/cogs': {
      id: '/w/$slug/settings/cogs'
      path: '/settings/cogs'
      fullPath: '/w/$slug/settings/cogs'
      preLoaderRoute: typeof WSlugSettingsCogsRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/expense-categories': {
      id: '/w/$slug/settings/expense-categories'
      path: '/settings/expense-categories'
      fullPath: '/w/$slug/settings/expense-categories'
      preLoaderRoute: typeof WSlugSettingsExpenseCategoriesRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/users': {
      id: '/w/$slug/settings/users'
      path: '/settings/users'
      fullPath: '/w/$slug/settings/users'
      preLoaderRoute: typeof WSlugSettingsUsersRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/workspace': {
      id: '/w/$slug/settings/workspace'
      path: '/settings/workspace'
      fullPath: '/w/$slug/settings/workspace'
      preLoaderRoute: typeof WSlugSettingsWorkspaceRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/stock/': {
      id: '/w/$slug/stock/'
      path: '/stock'
      fullPath: '/w/$slug/stock/'
      preLoaderRoute: typeof WSlugStockIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/stock/movements': {
      id: '/w/$slug/stock/movements'
      path: '/stock/movements'
      fullPath: '/w/$slug/stock/movements'
      preLoaderRoute: typeof WSlugStockMovementsRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/stock/wip': {
      id: '/w/$slug/stock/wip'
      path: '/stock/wip'
      fullPath: '/w/$slug/stock/wip'
      preLoaderRoute: typeof WSlugStockWipRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/vendor-prices/': {
      id: '/w/$slug/vendor-prices/'
      path: '/vendor-prices'
      fullPath: '/w/$slug/vendor-prices/'
      preLoaderRoute: typeof WSlugVendorPricesIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/adjustments/$adjustmentId/': {
      id: '/w/$slug/adjustments/$adjustmentId/'
      path: '/adjustments/$adjustmentId'
      fullPath: '/w/$slug/adjustments/$adjustmentId/'
      preLoaderRoute: typeof WSlugAdjustmentsAdjustmentIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/assemblies/$assemblyId/': {
      id: '/w/$slug/assemblies/$assemblyId/'
      path: '/assemblies/$assemblyId'
      fullPath: '/w/$slug/assemblies/$assemblyId/'
      preLoaderRoute: typeof WSlugAssembliesAssemblyIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/batches/$batchId/': {
      id: '/w/$slug/batches/$batchId/'
      path: '/batches/$batchId'
      fullPath: '/w/$slug/batches/$batchId/'
      preLoaderRoute: typeof WSlugBatchesBatchIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/batches/$batchId/complete': {
      id: '/w/$slug/batches/$batchId/complete'
      path: '/batches/$batchId/complete'
      fullPath: '/w/$slug/batches/$batchId/complete'
      preLoaderRoute: typeof WSlugBatchesBatchIdCompleteRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/channels/$channelId/': {
      id: '/w/$slug/channels/$channelId/'
      path: '/channels/$channelId'
      fullPath: '/w/$slug/channels/$channelId/'
      preLoaderRoute: typeof WSlugChannelsChannelIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/channels/$channelId/edit': {
      id: '/w/$slug/channels/$channelId/edit'
      path: '/channels/$channelId/edit'
      fullPath: '/w/$slug/channels/$channelId/edit'
      preLoaderRoute: typeof WSlugChannelsChannelIdEditRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/dispatches/$dispatchId/': {
      id: '/w/$slug/dispatches/$dispatchId/'
      path: '/dispatches/$dispatchId'
      fullPath: '/w/$slug/dispatches/$dispatchId/'
      preLoaderRoute: typeof WSlugDispatchesDispatchIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/dispatches/$dispatchId/print': {
      id: '/w/$slug/dispatches/$dispatchId/print'
      path: '/dispatches/$dispatchId/print'
      fullPath: '/w/$slug/dispatches/$dispatchId/print'
      preLoaderRoute: typeof WSlugDispatchesDispatchIdPrintRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/expenses/$expenseId/edit': {
      id: '/w/$slug/expenses/$expenseId/edit'
      path: '/expenses/$expenseId/edit'
      fullPath: '/w/$slug/expenses/$expenseId/edit'
      preLoaderRoute: typeof WSlugExpensesExpenseIdEditRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/machines/$machineId/': {
      id: '/w/$slug/machines/$machineId/'
      path: '/machines/$machineId'
      fullPath: '/w/$slug/machines/$machineId/'
      preLoaderRoute: typeof WSlugMachinesMachineIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/machines/$machineId/edit': {
      id: '/w/$slug/machines/$machineId/edit'
      path: '/machines/$machineId/edit'
      fullPath: '/w/$slug/machines/$machineId/edit'
      preLoaderRoute: typeof WSlugMachinesMachineIdEditRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/materials/pools/new': {
      id: '/w/$slug/materials/pools/new'
      path: '/materials/pools/new'
      fullPath: '/w/$slug/materials/pools/new'
      preLoaderRoute: typeof WSlugMaterialsPoolsNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/materials/restocks/': {
      id: '/w/$slug/materials/restocks/'
      path: '/materials/restocks'
      fullPath: '/w/$slug/materials/restocks/'
      preLoaderRoute: typeof WSlugMaterialsRestocksIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/materials/restocks/new': {
      id: '/w/$slug/materials/restocks/new'
      path: '/materials/restocks/new'
      fullPath: '/w/$slug/materials/restocks/new'
      preLoaderRoute: typeof WSlugMaterialsRestocksNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/products/$productId/': {
      id: '/w/$slug/products/$productId/'
      path: '/products/$productId'
      fullPath: '/w/$slug/products/$productId/'
      preLoaderRoute: typeof WSlugProductsProductIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/products/$productId/bom': {
      id: '/w/$slug/products/$productId/bom'
      path: '/products/$productId/bom'
      fullPath: '/w/$slug/products/$productId/bom'
      preLoaderRoute: typeof WSlugProductsProductIdBomRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/products/$productId/edit': {
      id: '/w/$slug/products/$productId/edit'
      path: '/products/$productId/edit'
      fullPath: '/w/$slug/products/$productId/edit'
      preLoaderRoute: typeof WSlugProductsProductIdEditRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/returns/$returnId/': {
      id: '/w/$slug/returns/$returnId/'
      path: '/returns/$returnId'
      fullPath: '/w/$slug/returns/$returnId/'
      preLoaderRoute: typeof WSlugReturnsReturnIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/sales-reports/$reportId/': {
      id: '/w/$slug/sales-reports/$reportId/'
      path: '/sales-reports/$reportId'
      fullPath: '/w/$slug/sales-reports/$reportId/'
      preLoaderRoute: typeof WSlugSalesReportsReportIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/opening-balances/': {
      id: '/w/$slug/settings/opening-balances/'
      path: '/settings/opening-balances'
      fullPath: '/w/$slug/settings/opening-balances/'
      preLoaderRoute: typeof WSlugSettingsOpeningBalancesIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/opening-balances/new': {
      id: '/w/$slug/settings/opening-balances/new'
      path: '/settings/opening-balances/new'
      fullPath: '/w/$slug/settings/opening-balances/new'
      preLoaderRoute: typeof WSlugSettingsOpeningBalancesNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/variants/$variantId/': {
      id: '/w/$slug/variants/$variantId/'
      path: '/variants/$variantId'
      fullPath: '/w/$slug/variants/$variantId/'
      preLoaderRoute: typeof WSlugVariantsVariantIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/variants/$variantId/edit': {
      id: '/w/$slug/variants/$variantId/edit'
      path: '/variants/$variantId/edit'
      fullPath: '/w/$slug/variants/$variantId/edit'
      preLoaderRoute: typeof WSlugVariantsVariantIdEditRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/materials/pools/$poolId/': {
      id: '/w/$slug/materials/pools/$poolId/'
      path: '/materials/pools/$poolId'
      fullPath: '/w/$slug/materials/pools/$poolId/'
      preLoaderRoute: typeof WSlugMaterialsPoolsPoolIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/materials/pools/$poolId/edit': {
      id: '/w/$slug/materials/pools/$poolId/edit'
      path: '/materials/pools/$poolId/edit'
      fullPath: '/w/$slug/materials/pools/$poolId/edit'
      preLoaderRoute: typeof WSlugMaterialsPoolsPoolIdEditRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/materials/restocks/$restockId/': {
      id: '/w/$slug/materials/restocks/$restockId/'
      path: '/materials/restocks/$restockId'
      fullPath: '/w/$slug/materials/restocks/$restockId/'
      preLoaderRoute: typeof WSlugMaterialsRestocksRestockIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/products/$productId/variants/new': {
      id: '/w/$slug/products/$productId/variants/new'
      path: '/products/$productId/variants/new'
      fullPath: '/w/$slug/products/$productId/variants/new'
      preLoaderRoute: typeof WSlugProductsProductIdVariantsNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/settings/opening-balances/$openingBalanceId/': {
      id: '/w/$slug/settings/opening-balances/$openingBalanceId/'
      path: '/settings/opening-balances/$openingBalanceId'
      fullPath: '/w/$slug/settings/opening-balances/$openingBalanceId/'
      preLoaderRoute: typeof WSlugSettingsOpeningBalancesOpeningBalanceIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/products/$productId/models/$modelId/': {
      id: '/w/$slug/products/$productId/models/$modelId/'
      path: '/products/$productId/models/$modelId'
      fullPath: '/w/$slug/products/$productId/models/$modelId/'
      preLoaderRoute: typeof WSlugProductsProductIdModelsModelIdIndexRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/products/$productId/models/$modelId/versions/$versionNo': {
      id: '/w/$slug/products/$productId/models/$modelId/versions/$versionNo'
      path: '/products/$productId/models/$modelId/versions/$versionNo'
      fullPath: '/w/$slug/products/$productId/models/$modelId/versions/$versionNo'
      preLoaderRoute: typeof WSlugProductsProductIdModelsModelIdVersionsVersionNoRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
    '/w/$slug/products/$productId/models/$modelId/versions/new': {
      id: '/w/$slug/products/$productId/models/$modelId/versions/new'
      path: '/products/$productId/models/$modelId/versions/new'
      fullPath: '/w/$slug/products/$productId/models/$modelId/versions/new'
      preLoaderRoute: typeof WSlugProductsProductIdModelsModelIdVersionsNewRouteImport
      parentRoute: typeof WSlugRouteRoute
    }
  }
}

interface WSlugRouteRouteChildren {
  WSlugAccountRoute: typeof WSlugAccountRoute
  WSlugWelcomeRoute: typeof WSlugWelcomeRoute
  WSlugIndexRoute: typeof WSlugIndexRoute
  WSlugAdjustmentsNewRoute: typeof WSlugAdjustmentsNewRoute
  WSlugAssembliesNewRoute: typeof WSlugAssembliesNewRoute
  WSlugBatchesNewRoute: typeof WSlugBatchesNewRoute
  WSlugChannelsNewRoute: typeof WSlugChannelsNewRoute
  WSlugCogsVariantIdRoute: typeof WSlugCogsVariantIdRoute
  WSlugDispatchesNewRoute: typeof WSlugDispatchesNewRoute
  WSlugExpensesNewRoute: typeof WSlugExpensesNewRoute
  WSlugGuideMcpRoute: typeof WSlugGuideMcpRoute
  WSlugMachinesNewRoute: typeof WSlugMachinesNewRoute
  WSlugProductsNewRoute: typeof WSlugProductsNewRoute
  WSlugReportsMonthlyRoute: typeof WSlugReportsMonthlyRoute
  WSlugReturnsNewRoute: typeof WSlugReturnsNewRoute
  WSlugSalesReportsNewRoute: typeof WSlugSalesReportsNewRoute
  WSlugSalesReportsOutstandingRoute: typeof WSlugSalesReportsOutstandingRoute
  WSlugSettingsCogsRoute: typeof WSlugSettingsCogsRoute
  WSlugSettingsExpenseCategoriesRoute: typeof WSlugSettingsExpenseCategoriesRoute
  WSlugSettingsUsersRoute: typeof WSlugSettingsUsersRoute
  WSlugSettingsWorkspaceRoute: typeof WSlugSettingsWorkspaceRoute
  WSlugStockMovementsRoute: typeof WSlugStockMovementsRoute
  WSlugStockWipRoute: typeof WSlugStockWipRoute
  WSlugAdjustmentsIndexRoute: typeof WSlugAdjustmentsIndexRoute
  WSlugAssembliesIndexRoute: typeof WSlugAssembliesIndexRoute
  WSlugBatchesIndexRoute: typeof WSlugBatchesIndexRoute
  WSlugChannelsIndexRoute: typeof WSlugChannelsIndexRoute
  WSlugCogsIndexRoute: typeof WSlugCogsIndexRoute
  WSlugDispatchesIndexRoute: typeof WSlugDispatchesIndexRoute
  WSlugExpensesIndexRoute: typeof WSlugExpensesIndexRoute
  WSlugGuideIndexRoute: typeof WSlugGuideIndexRoute
  WSlugMachinesIndexRoute: typeof WSlugMachinesIndexRoute
  WSlugMaterialsIndexRoute: typeof WSlugMaterialsIndexRoute
  WSlugProductsIndexRoute: typeof WSlugProductsIndexRoute
  WSlugReturnsIndexRoute: typeof WSlugReturnsIndexRoute
  WSlugSalesReportsIndexRoute: typeof WSlugSalesReportsIndexRoute
  WSlugStockIndexRoute: typeof WSlugStockIndexRoute
  WSlugVendorPricesIndexRoute: typeof WSlugVendorPricesIndexRoute
  WSlugBatchesBatchIdCompleteRoute: typeof WSlugBatchesBatchIdCompleteRoute
  WSlugChannelsChannelIdEditRoute: typeof WSlugChannelsChannelIdEditRoute
  WSlugDispatchesDispatchIdPrintRoute: typeof WSlugDispatchesDispatchIdPrintRoute
  WSlugExpensesExpenseIdEditRoute: typeof WSlugExpensesExpenseIdEditRoute
  WSlugMachinesMachineIdEditRoute: typeof WSlugMachinesMachineIdEditRoute
  WSlugMaterialsPoolsNewRoute: typeof WSlugMaterialsPoolsNewRoute
  WSlugMaterialsRestocksNewRoute: typeof WSlugMaterialsRestocksNewRoute
  WSlugProductsProductIdBomRoute: typeof WSlugProductsProductIdBomRoute
  WSlugProductsProductIdEditRoute: typeof WSlugProductsProductIdEditRoute
  WSlugSettingsOpeningBalancesNewRoute: typeof WSlugSettingsOpeningBalancesNewRoute
  WSlugVariantsVariantIdEditRoute: typeof WSlugVariantsVariantIdEditRoute
  WSlugAdjustmentsAdjustmentIdIndexRoute: typeof WSlugAdjustmentsAdjustmentIdIndexRoute
  WSlugAssembliesAssemblyIdIndexRoute: typeof WSlugAssembliesAssemblyIdIndexRoute
  WSlugBatchesBatchIdIndexRoute: typeof WSlugBatchesBatchIdIndexRoute
  WSlugChannelsChannelIdIndexRoute: typeof WSlugChannelsChannelIdIndexRoute
  WSlugDispatchesDispatchIdIndexRoute: typeof WSlugDispatchesDispatchIdIndexRoute
  WSlugMachinesMachineIdIndexRoute: typeof WSlugMachinesMachineIdIndexRoute
  WSlugMaterialsRestocksIndexRoute: typeof WSlugMaterialsRestocksIndexRoute
  WSlugProductsProductIdIndexRoute: typeof WSlugProductsProductIdIndexRoute
  WSlugReturnsReturnIdIndexRoute: typeof WSlugReturnsReturnIdIndexRoute
  WSlugSalesReportsReportIdIndexRoute: typeof WSlugSalesReportsReportIdIndexRoute
  WSlugSettingsOpeningBalancesIndexRoute: typeof WSlugSettingsOpeningBalancesIndexRoute
  WSlugVariantsVariantIdIndexRoute: typeof WSlugVariantsVariantIdIndexRoute
  WSlugMaterialsPoolsPoolIdEditRoute: typeof WSlugMaterialsPoolsPoolIdEditRoute
  WSlugProductsProductIdVariantsNewRoute: typeof WSlugProductsProductIdVariantsNewRoute
  WSlugMaterialsPoolsPoolIdIndexRoute: typeof WSlugMaterialsPoolsPoolIdIndexRoute
  WSlugMaterialsRestocksRestockIdIndexRoute: typeof WSlugMaterialsRestocksRestockIdIndexRoute
  WSlugSettingsOpeningBalancesOpeningBalanceIdIndexRoute: typeof WSlugSettingsOpeningBalancesOpeningBalanceIdIndexRoute
  WSlugProductsProductIdModelsModelIdIndexRoute: typeof WSlugProductsProductIdModelsModelIdIndexRoute
  WSlugProductsProductIdModelsModelIdVersionsVersionNoRoute: typeof WSlugProductsProductIdModelsModelIdVersionsVersionNoRoute
  WSlugProductsProductIdModelsModelIdVersionsNewRoute: typeof WSlugProductsProductIdModelsModelIdVersionsNewRoute
}

const WSlugRouteRouteChildren: WSlugRouteRouteChildren = {
  WSlugAccountRoute: WSlugAccountRoute,
  WSlugWelcomeRoute: WSlugWelcomeRoute,
  WSlugIndexRoute: WSlugIndexRoute,
  WSlugAdjustmentsNewRoute: WSlugAdjustmentsNewRoute,
  WSlugAssembliesNewRoute: WSlugAssembliesNewRoute,
  WSlugBatchesNewRoute: WSlugBatchesNewRoute,
  WSlugChannelsNewRoute: WSlugChannelsNewRoute,
  WSlugCogsVariantIdRoute: WSlugCogsVariantIdRoute,
  WSlugDispatchesNewRoute: WSlugDispatchesNewRoute,
  WSlugExpensesNewRoute: WSlugExpensesNewRoute,
  WSlugGuideMcpRoute: WSlugGuideMcpRoute,
  WSlugMachinesNewRoute: WSlugMachinesNewRoute,
  WSlugProductsNewRoute: WSlugProductsNewRoute,
  WSlugReportsMonthlyRoute: WSlugReportsMonthlyRoute,
  WSlugReturnsNewRoute: WSlugReturnsNewRoute,
  WSlugSalesReportsNewRoute: WSlugSalesReportsNewRoute,
  WSlugSalesReportsOutstandingRoute: WSlugSalesReportsOutstandingRoute,
  WSlugSettingsCogsRoute: WSlugSettingsCogsRoute,
  WSlugSettingsExpenseCategoriesRoute: WSlugSettingsExpenseCategoriesRoute,
  WSlugSettingsUsersRoute: WSlugSettingsUsersRoute,
  WSlugSettingsWorkspaceRoute: WSlugSettingsWorkspaceRoute,
  WSlugStockMovementsRoute: WSlugStockMovementsRoute,
  WSlugStockWipRoute: WSlugStockWipRoute,
  WSlugAdjustmentsIndexRoute: WSlugAdjustmentsIndexRoute,
  WSlugAssembliesIndexRoute: WSlugAssembliesIndexRoute,
  WSlugBatchesIndexRoute: WSlugBatchesIndexRoute,
  WSlugChannelsIndexRoute: WSlugChannelsIndexRoute,
  WSlugCogsIndexRoute: WSlugCogsIndexRoute,
  WSlugDispatchesIndexRoute: WSlugDispatchesIndexRoute,
  WSlugExpensesIndexRoute: WSlugExpensesIndexRoute,
  WSlugGuideIndexRoute: WSlugGuideIndexRoute,
  WSlugMachinesIndexRoute: WSlugMachinesIndexRoute,
  WSlugMaterialsIndexRoute: WSlugMaterialsIndexRoute,
  WSlugProductsIndexRoute: WSlugProductsIndexRoute,
  WSlugReturnsIndexRoute: WSlugReturnsIndexRoute,
  WSlugSalesReportsIndexRoute: WSlugSalesReportsIndexRoute,
  WSlugStockIndexRoute: WSlugStockIndexRoute,
  WSlugVendorPricesIndexRoute: WSlugVendorPricesIndexRoute,
  WSlugBatchesBatchIdCompleteRoute: WSlugBatchesBatchIdCompleteRoute,
  WSlugChannelsChannelIdEditRoute: WSlugChannelsChannelIdEditRoute,
  WSlugDispatchesDispatchIdPrintRoute: WSlugDispatchesDispatchIdPrintRoute,
  WSlugExpensesExpenseIdEditRoute: WSlugExpensesExpenseIdEditRoute,
  WSlugMachinesMachineIdEditRoute: WSlugMachinesMachineIdEditRoute,
  WSlugMaterialsPoolsNewRoute: WSlugMaterialsPoolsNewRoute,
  WSlugMaterialsRestocksNewRoute: WSlugMaterialsRestocksNewRoute,
  WSlugProductsProductIdBomRoute: WSlugProductsProductIdBomRoute,
  WSlugProductsProductIdEditRoute: WSlugProductsProductIdEditRoute,
  WSlugSettingsOpeningBalancesNewRoute: WSlugSettingsOpeningBalancesNewRoute,
  WSlugVariantsVariantIdEditRoute: WSlugVariantsVariantIdEditRoute,
  WSlugAdjustmentsAdjustmentIdIndexRoute:
    WSlugAdjustmentsAdjustmentIdIndexRoute,
  WSlugAssembliesAssemblyIdIndexRoute: WSlugAssembliesAssemblyIdIndexRoute,
  WSlugBatchesBatchIdIndexRoute: WSlugBatchesBatchIdIndexRoute,
  WSlugChannelsChannelIdIndexRoute: WSlugChannelsChannelIdIndexRoute,
  WSlugDispatchesDispatchIdIndexRoute: WSlugDispatchesDispatchIdIndexRoute,
  WSlugMachinesMachineIdIndexRoute: WSlugMachinesMachineIdIndexRoute,
  WSlugMaterialsRestocksIndexRoute: WSlugMaterialsRestocksIndexRoute,
  WSlugProductsProductIdIndexRoute: WSlugProductsProductIdIndexRoute,
  WSlugReturnsReturnIdIndexRoute: WSlugReturnsReturnIdIndexRoute,
  WSlugSalesReportsReportIdIndexRoute: WSlugSalesReportsReportIdIndexRoute,
  WSlugSettingsOpeningBalancesIndexRoute:
    WSlugSettingsOpeningBalancesIndexRoute,
  WSlugVariantsVariantIdIndexRoute: WSlugVariantsVariantIdIndexRoute,
  WSlugMaterialsPoolsPoolIdEditRoute: WSlugMaterialsPoolsPoolIdEditRoute,
  WSlugProductsProductIdVariantsNewRoute:
    WSlugProductsProductIdVariantsNewRoute,
  WSlugMaterialsPoolsPoolIdIndexRoute: WSlugMaterialsPoolsPoolIdIndexRoute,
  WSlugMaterialsRestocksRestockIdIndexRoute:
    WSlugMaterialsRestocksRestockIdIndexRoute,
  WSlugSettingsOpeningBalancesOpeningBalanceIdIndexRoute:
    WSlugSettingsOpeningBalancesOpeningBalanceIdIndexRoute,
  WSlugProductsProductIdModelsModelIdIndexRoute:
    WSlugProductsProductIdModelsModelIdIndexRoute,
  WSlugProductsProductIdModelsModelIdVersionsVersionNoRoute:
    WSlugProductsProductIdModelsModelIdVersionsVersionNoRoute,
  WSlugProductsProductIdModelsModelIdVersionsNewRoute:
    WSlugProductsProductIdModelsModelIdVersionsNewRoute,
}

const WSlugRouteRouteWithChildren = WSlugRouteRoute._addFileChildren(
  WSlugRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  Sign_upRoute: Sign_upRoute,
  WSlugRouteRoute: WSlugRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
